import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

// ContactAutocompleteResult represents a single result for the autocomplete dropdown
export interface ContactAutocompleteResult {
  value: string;  // UUID
  label: string;  // e.g., "Acme Inc - 123 Main St"
}

// ContactDetails represents the full contact data including addresses, profile, etc.
export interface ContactDetails {
  name: string;
  message: string;
  code: string;
  addresses: any[];
  profile: any[];
  default_services: any[];
}

@Injectable({
  providedIn: 'root'
})
export class ContactAutocompleteService {

  constructor(private http: HttpClient) {}

  /**
   * Search for contacts for use in an autocomplete input.
   * @param type e.g., 'shipper_contact_list', 'carrier_contact_list', etc.
   * @param query Minimum 3 characters recommended
   */
  search(type: string, query: string): Observable<ContactAutocompleteResult[]> {
    if (!query || query.length < 3) return of([]);
    const url = `/api/work_orders/contact_autofill.php?type=${encodeURIComponent(type)}&search=${encodeURIComponent(query)}`;
    return this.http.get<ContactAutocompleteResult[]>(url).pipe(
      map(response => response || [])
    );
  }

  /**
   * Fetch full contact detail data using a contact UUID.
   * @param uuid Contact UUID
   */
  getDetails(uuid: string): Observable<ContactDetails> {
    const url = `/api/work_orders/contact_autofill.php?type=contact_data&uuid=${encodeURIComponent(uuid)}`;
    return this.http.get<any>(url).pipe(
      map(response => (Array.isArray(response) ? response[0] : {}))
    );
  }
}